import { Observable, of } from 'rxjs'

import type { CustomError } from '../errorTools'

export const coerceCaughtToLeft = (error: unknown): Observable<{ _tag: 'Left'; error: Error }> => {
  if (error instanceof Error) {
    return of({ _tag: 'Left', message: error.message, error })
  }
  const message =
    error != null && typeof error === 'object'
      ? (error as Partial<{ message?: unknown }>).message
      : undefined
  return of({
    _tag: 'Left' as const,
    error: new Error(message && typeof message === 'string' ? message : `${error}`),
  })
}

export const coerceCaughtToLeftWith =
  <E extends CustomError>(project: (caught: Error) => E) =>
  (error: unknown): Observable<{ _tag: 'Left'; error: E }> => {
    if (error instanceof Error) {
      return of({ _tag: 'Left', error: project(error) })
    }
    const message =
      error != null && typeof error === 'object'
        ? (error as Partial<{ message?: unknown }>).message
        : undefined
    return of({
      _tag: 'Left' as const,
      error: project(new Error(message && typeof message === 'string' ? message : `${error}`)),
    })
  }
